import styled, {css} from "styled-components"
import {H4} from "@irati/ui/src/Typography"

export const Background = styled.div`
  background: ${({theme}) => theme.colors.greys.lightest};
  ${({theme}) => css`
    margin: ${theme.spacing.three} -${theme.spacing.eight};
    padding: 0 ${theme.spacing.eight};

    ${theme.mediaQueries.minWidthMedia.desktop`
      margin: ${theme.spacing.three} -${theme.spacing.three};
      padding: 0 ${theme.spacing.two};
    `}
  `}
`

export const Wrapper = styled.div`
  ${({theme}) => css`
    padding: ${theme.spacing.four} ${theme.spacing.two};
  
    ${theme.mediaQueries.minWidthMedia.tablet`
      padding: ${theme.spacing.four};
    `}
  `}
`
export const Container = styled.div`
  width: 100%;
`

export const StyledH4 = styled(H4)`
  font-size: 21px;
  text-align: center;
  line-height: 1.3;
`
